// AutoPauseDisplay — US-133 (purple banner shown on `paused_auto`).

import { useT } from '@barel/i18n';
import { Banner } from '@barel/ui';

export interface AutoPauseDisplayProps {
  reason: string;
}

export function AutoPauseDisplay({ reason }: AutoPauseDisplayProps) {
  const t = useT('campaigns');
  return (
    <Banner tone="magenta" variant="soft" data-testid="auto-pause-banner">
      {t('detail.pausedAutoBanner', { reason })}
    </Banner>
  );
}
